import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Sidebar from '../../views/app/Sidebar';
import { appActions } from '../../store/modules/app';
import { SIDEBAR_ITEM_LIST } from '../../constants/service/common/sidebarConstants';

const SidebarContainer = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const sidebar = useSelector((state) => state.app.sidebar);

  const [sidebarState, setSidebarState] = useState({
    /**
     *  현재 활성중인 사이드바 상단 값
     */
    currentKey: null,
    /**
     *  현재 path
     */
    currentPath: null,
    /**
     *  메뉴 리스트
     */
    sidebarItemList: SIDEBAR_ITEM_LIST,
    /**
     *  메뉴 검색 키워드
     */
    searchKeyword: '',
  });

  const changeCurrent = (current) => {
    if (sidebar.isCollapsed) {
      dispatch(appActions.sidebarToggleCollapse(false));
    }

    setSidebarState({
      ...sidebarState,
      ...current,
    });
  };

  const onSearchMenu = (searchKeyword) => {
    let sidebarItemList;
    if (searchKeyword && searchKeyword !== '') {
      sidebarItemList = SIDEBAR_ITEM_LIST.filter((item) => item.text && item.text.indexOf(searchKeyword) !== -1);
    } else if (!searchKeyword || searchKeyword === '') {
      sidebarItemList = SIDEBAR_ITEM_LIST;
    }
    setSidebarState({
      ...sidebarState,
      sidebarItemList,
      searchKeyword,
    });
  };

  useEffect(() => {
    const currentMenuItem = SIDEBAR_ITEM_LIST.find(
      (item) =>
        item.path === location.pathname || item.subMenu?.find((sub) => sub.path === location.pathname) !== undefined,
    );
    const currentKey = currentMenuItem ? currentMenuItem.key : null;

    setSidebarState((prevState) => ({
      ...prevState,
      currentKey,
      currentPath: location.pathname,
    }));
  }, [location.pathname]);

  return (
    <Sidebar
      {...sidebarState}
      changeCurrent={changeCurrent}
      sidebar={sidebar}
      sidebarItemList={sidebarState.sidebarItemList}
      searchKeyword={sidebarState.searchKeyword}
      onSearchMenu={onSearchMenu}
    />
  );
};

export default SidebarContainer;
